import React from 'react';
import { TypographyContainer, TypographyComponentProps, TypographySize } from './Typography.styles';
import { componentPropsToStyledProps } from 'src/app/styles/helper';

export interface TypographyProps extends TypographyComponentProps {
  children?: React.ReactNode;
  className?: string;
  text?: string | React.ReactNode;
}

const HEADING_TAG_MAP: Record<TypographySize, 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'> = {
  '2xl': 'h1',
  xl: 'h2',
  lg: 'h3',
  md: 'h4',
  sm: 'h5',
  xs: 'h6',
};

const getHeadingTag = (size: TypographySize): 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' => {
  return HEADING_TAG_MAP[size];
};

export const Typography = ({ children, text, className, type, size, ...props }: TypographyProps): JSX.Element => {
  const tag = type === 'heading' ? getHeadingTag(size) : 'p';

  return (
    <TypographyContainer
      className={className}
      as={tag}
      $type={type}
      $size={size}
      {...componentPropsToStyledProps(props)}
    >
      {children || text}
    </TypographyContainer>
  );
};

export default Typography;
